import { Role, User } from 'models/User';

export default {
  checkRolesForUser(user: User, roles: Role[]) {
    return roles.includes(user.role);
  },
};
